module.exports = __webpack_public_path__ + "img/dashboard-arrow-right.d4a28c39.svg";